var PageReadyTiming;
(function(PageReadyTiming2) {
  PageReadyTiming2["CUSTOM"] = "CUSTOM";
  PageReadyTiming2["ACTUAL_FMP"] = "ACTUAL_FMP";
})(PageReadyTiming || (PageReadyTiming = {}));
var UserDropReason;
(function(UserDropReason2) {
  UserDropReason2["ABORT"] = "ABORT";
  UserDropReason2["CRASH"] = "CRASH";
})(UserDropReason || (UserDropReason = {}));
var CUJStatus;
(function(CUJStatus2) {
  CUJStatus2["START"] = "START";
  CUJStatus2["IN_PROGRESS"] = "IN_PROGRESS";
  CUJStatus2["FAILURE"] = "FAILURE";
  CUJStatus2["FINISH"] = "FINISH";
  CUJStatus2["ABORT"] = "ABORT";
})(CUJStatus || (CUJStatus = {}));
export {
  CUJStatus,
  PageReadyTiming,
  UserDropReason
};
